export enum AttachmentSender {
  Bot = 'bot',
  User = 'user',
}
